import React, { useState, useEffect } from 'react'
import StudentTopMenu from './studenttopmenu'
import StudentInfoBox from './studentinfobox'
import { getStudentIdData } from '../../../lib/studentgradeinmonthlistview'
import { getStudentIdData as getStudentLessons } from '../../../lib/studentlessons'
import { useParams } from 'react-router-dom'

export default function AdminStudentGradeList() {
  const [studentGradeList, setStudentGradeList] = useState()
  const [studentInfo, setStudentInfo] = useState()
  const [studentLessons, setStudentLessons] = useState()
  const [monthList, setMonthList] = useState([
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June'
  ])

  let { slug } = useParams()

  async function GetData() {
    const info = await getStudentIdData(slug)
    setStudentGradeList(info)
    //setStudentInfo(info[0].name + " " + info[0].surname)
    console.log('info', info)

    const lessons = await getStudentLessons(slug)
    setStudentLessons(lessons)
  }

  useEffect(() => {
    GetData()
    //GetGrade(monthList[0],22);
  }, [])

  function GetGrade(monthName, lessonId) {
    console.log('GetGrade', studentGradeList)

    const result = studentGradeList.filter((grades) => {
      return grades.month === monthName && grades.lesson === lessonId
    })

    // console.log("result",result);
    if (result.length > 0) return result[0].grade
    else return 0
  }

  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <StudentInfoBox slug={slug} />
            <StudentTopMenu slug={slug} activeMenu={'GradeList'} />
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>
                      Student Grade List -{' '}
                      <span className='fs-2 text-info'>{studentInfo}</span>
                    </h4>
                  </div>
                  <div className='comman-space pb-0'>
                    <div className='settings-referral-blk course-instruct-blk  table-responsive'>
                      {/* Instructor Users */}
                      <table className='table table-striped mb-0 table-hover'>
                        <thead>
                          <tr>
                            <th>--</th>
                            {studentLessons
                              ? studentLessons.map(function (less) {
                                  return (
                                    <>
                                      <th key={less.id}>{less.lessonName}</th>
                                    </>
                                  )
                                })
                              : ''}
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {monthList.map(function (data, ix) {
                            return (
                              <tr key={ix}>
                                <td>{data}</td>
                                {studentLessons
                                  ? studentLessons.map(function (less) {
                                      return (
                                        <>
                                          <td key={less.id}>
                                            {GetGrade(data, less.id)}
                                          </td>
                                        </>
                                      )
                                    })
                                  : ''}
                                <td></td>
                              </tr>
                            )
                          })}
                          {/*}
                              {studentGradeList ? studentGradeList.map(function (data) {
                          return (
                                <tr key = {data.id}>
                                  <td>
                                    {data.id}
                                  </td>
                                  <td>{data.lessonname}</td>
                                  <td>{data.month}</td>
                                  <td>
                                    {data.grade > 70 ? <span className="badge info-low">{data.grade}</span> : 
                                    <span className="badge info-high">
                                     {data.grade}
                                    </span>} 
                                  </td>
                                </tr>
                                  )
                                })  : ""}

                                */}
                        </tbody>
                      </table>
                      {/* Instructor List */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
